import SectionTitle from 'components/global/SectionTitle'
import { Section } from 'components/grid'
import React from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'
import Modules from 'components/100-book-challenge/Modules'

export default function OneHundredBookChallengeSpanish({ ...props }) {
	return (
		<Section id={formatSectionId(props)} margin="mt-20" className="scroll-mt-14">
			<SectionTitle
				title={[
					<span key={Math.random()}>
						100 Book Challenge<sup>®</sup> (Spanish)
					</span>
				]}
				text="100 Book Challenge accelerates learning in any core program by adding daily opportunities to transfer taught skills to high-interest texts."
			/>
			<Modules language="spanish" showFrameworks />
		</Section>
	)
}
